import React from 'react'
import { TabRadio, InputLabel as Label, FormError } from '../../../Common'
import {
  useCheckoutFormPaymentState,
  useLocalLabels,
} from '@sentecacommerce-theme/lib'
import { CheckoutLabels } from '../../checkout.props'

export const CheckoutPayment = () => {
  const { paymentMethods, errors } = useCheckoutFormPaymentState()
  const labels = useLocalLabels<CheckoutLabels>()

  const paymentsMap = {
    cod: labels?.codLabel,
    borica: labels?.boricaLabel,
  }

  const options = paymentMethods?.map((payment) => {
    return {
      label: paymentsMap[payment.key] || '',
      isSelected: payment.selected,
      onClick: payment.onClick,
      key: payment.key,
    }
  })

  return (
    <Label htmlFor="">
      {!options && <p>{labels?.pickACourier}</p>}
      {!!options && (
        <TabRadio
          tabStyle="button"
          name="checkout-billing-type"
          options={options}
        />
      )}
      <FormError errors={errors} fieldName="paymentMethod" />
    </Label>
  )
}
